exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-suggest-faqs[data-v-59bd662a]{\n  margin-top:1em;\n}\n.form-suggest-faqs h3[data-v-59bd662a]{\n  border-bottom:1px solid #DEDEDE;\n  margin-top:0.5em;\n  margin-bottom:0.5em;\n}\nul.faq-result[data-v-59bd662a]{\n  padding-left:1em;\n}\n.faq-result li[data-v-59bd662a]{\n  list-style-type:'\\30FB';\n}\nul.faq-result li[data-v-59bd662a]::marker{\n  font-weight:normal;\n}\n", ""]);

// exports
